<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
  >
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  methods: {},
}
</script>
